export default {
  url: 'https://mm6x5b4i9g.execute-api.eu-central-1.amazonaws.com/prod'
}